export default {
  es: {
    company_name: "Nombre de la empresa",
    contact_name: "Nombre y apellidos del contacto",
    phone: "Teléfono",
    email: "Email",
    message: "Mensaje",
    attach_invoice: "Adjuntar factura",
    power: "potencia",
    consumption_p1: "P1",
    consumption_p2: "P2",
    consumption_p3: "P3",
    period_start: "desde",
    period_end: "hasta",
    amount_paid: "cantidad",
  },
  en: {},
};



// WEBPACK FOOTER //
// ./src/translations/fields.js